import React, { Component } from 'react';
import { connect } from 'react-redux';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import ApplicationMessagesWrapper from '../inAppMessages/ApplicationMessagesWrapper';
import ReadOnlyWrapper from '../authorization/ReadOnlyWrapper';
import Logger, {ALL_MESSAGES, LOG_LEVELS} from '../../utils/logger';
import Modal from 'react-responsive-modal';
import UploadPanel from '../upload/UploadPanel';
import FileSaver from 'file-saver';
import _ from 'underscore';
import HighlightOnInAppMessage from '../inAppMessages/HighlightOninAppMessage';
import FILING_CONTROLLER from '../../controllers/filing';
import { withFullStoryExclude } from '../../utils/fullStoryHelper';

const FORM_NAME = 'DE_SUBMIT_FILING';
const log = new Logger(FORM_NAME, LOG_LEVELS.DEBUG);
const MODAL_CLASSNAMES =  {
    modal: 'modal-full-width'
};
const MAX_FILE_SIZE_IN_MB = 3
const MAX_FILE_SIZE_IN_BYTES = MAX_FILE_SIZE_IN_MB * 1000;
const MAX_PIN_LENGTH = 50;


class DESubmitFiling extends Component {
    constructor(props) {
        super(props);
        this.state = Object.assign({ certificatePIN: "", certificateFile: undefined}, this.state, { isSubmitPopupOpen: false});
        this.onCertificatePINEntered = this.onCertificatePINEntered.bind(this);
    }

    onOpenModal() {
        this.setState({isSubmitPopupOpen: true, certificatePIN: "", certificateFile: undefined });
    }

    onCloseModal() {
        log.clearAllDictionaryErrors();
        this.setState({certificatePIN: "", certificateFile: undefined,isSubmitPopupOpen: false });
    }

    onCertificatePINEntered(evt) {
        return (evt) => {
            log.clearDictionaryError(ALL_MESSAGES.SUBMIT_FILING_DE_BLANK_PIN);
            log.clearDictionaryError(ALL_MESSAGES.SUBMIT_FILING_DE_MAX_PIN);
            this.setState({certificatePIN: evt.target.value });
        };
    }

    onUploadRequest(filesToBeSent) {
        log.clearDictionaryError(ALL_MESSAGES.SUBMIT_FILING_DE_BLANK_FILE);
        log.debug('onUploadRequest(): ', filesToBeSent);
        if(!filesToBeSent.length){
            log.setDictionaryMessage(ALL_MESSAGES.SUBMIT_FILING_DE_BLANK_FILE);
            return;
        }
        log.setDictionaryMessage(ALL_MESSAGES.SUBMIT_FILING_DE_FILE_UPLOAD_SUCCESS);
        this.setState({certificateFile: filesToBeSent[0]});
    }

    onClearRequest() {
        log.debug('onClearRequest():');
        log.clearDictionaryError(ALL_MESSAGES.SUBMIT_FILING_DE_FILE_UPLOAD_SUCCESS);
        this.setState({certificateFile: undefined});
    }
    onSubmitReport(){
        var IsValid = true;
        log.clearAllDictionaryErrors();
        log.debug('onSubmitReport ',this.props);
        if(_.isEmpty(this.state.certificatePIN))
        {
            log.setDictionaryMessage(ALL_MESSAGES.SUBMIT_FILING_DE_BLANK_PIN);
            IsValid = false;
        }
        if(this.state.certificatePIN.length > MAX_PIN_LENGTH)
        {
            log.setDictionaryMessage(ALL_MESSAGES.SUBMIT_FILING_DE_MAX_PIN);
            IsValid = false;
        }
        if (!this.state.certificateFile || !this.state.certificateFile.size){
            log.setDictionaryMessage(ALL_MESSAGES.SUBMIT_FILING_DE_BLANK_FILE);
            IsValid = false;
        }
        if(!IsValid)
            return;
        this.setState({isSubmitPopupOpen: false });
        const callback = (response, filename) => {
            log.debug('SubmitDEReport got an success: in callback ', response);
            let fileName = filename + '.pdf';
            FileSaver.saveAs(response, fileName);
            log.debug('SubmitDEReport got an success: ', response);
            //on success call approve report
            this.props.onApprove();
        };

        const reportType = this.props.isVATFiling ? 'vat' : 'ecListing';
        this.props.doSubmitDEReport(this.state.certificateFile, this.props.uri, this.state.certificatePIN, reportType, this.props.filename, callback);
    }
    UNSAFE_componentWillMount() {
        log.clearAllDictionaryErrors();
    }
    render() {
        log.debug('render(): ', this.props);
        const transactionFileTypes = [".pfx"];
        
        return (
            <>
                <ApplicationMessagesWrapper
                    messageIds={[ ALL_MESSAGES.VAT_RETURN_SUBMISSION_FAILED ]}
                    messageType="applicationError"
                />
                {/* Do not put the ApplicationMessages under the button as this will output a row after the button, pushing any other component next to this button down and displaying the message inbetween */}
                <ReadOnlyWrapper>
                    <button className="primary mb20" onClick={() => this.onOpenModal()}>{this.props.isVATFiling ? <LanguageStringResolver string='filingPage_SubmitVATBtn'/> : <LanguageStringResolver string='submitFilingDE_ECL_Submit'/>}</button>
                </ReadOnlyWrapper>
                <Modal
                    center
                    classNames={MODAL_CLASSNAMES}
                    open={this.state.isSubmitPopupOpen}
                    onClose={() => this.onCloseModal()}
                >
                    <div>
                        <h2><LanguageStringResolver string='submitFilingDE_Title'/></h2>
                        <p className="mt20"><LanguageStringResolver string='submitFilingDE_SubTitle'/></p>
                        
                        <ApplicationMessagesWrapper
                            messageIds={[ALL_MESSAGES.SUBMIT_FILING_DE_FILE_UPLOAD_SUCCESS]}
                            messageType="applicationSuccess"
                        />
                        <ApplicationMessagesWrapper
                            scopes={[FORM_NAME]}
                            messageIds={
                                [
                                    ALL_MESSAGES.SUBMIT_FILING_DE_BLANK_PIN, ALL_MESSAGES.SUBMIT_FILING_DE_BLANK_FILE, ALL_MESSAGES.SUBMIT_FILING_DE_MAX_PIN
                                ]
                            }
                            messageType="applicationError"
                        />
                            <HighlightOnInAppMessage
                                scopes={[FORM_NAME]}
                                messageIds={[ ALL_MESSAGES.SUBMIT_FILING_DE_BLANK_PIN, ALL_MESSAGES.SUBMIT_FILING_DE_MAX_PIN]}
                            >
                                <p>
                                <label className="mt10"><LanguageStringResolver string='submitFilingDE_PIN'/> </label>
                                 <input
                                    type="password"
                                    className={withFullStoryExclude()}
                                    onChange={this.onCertificatePINEntered()}
                                    name="certificatePIN"
                                    value={this.state.certificatePIN}
                                 />
                                </p>
                            </HighlightOnInAppMessage>
                        <s-box>
                        <s-col span="12">
                            <label className="mt10"><LanguageStringResolver string='submitFilingDE_Certificate'/>:</label>
                            <UploadPanel
                                uploadLimit={1}
                                acceptTypes={transactionFileTypes}
                                onUploadRequest={this.onUploadRequest.bind(this)}
                                maxSizeInKB={MAX_FILE_SIZE_IN_BYTES}
                                clearSelection={false}
                                onClearFiles={this.onClearRequest.bind(this)}
                            />
                        </s-col>
                            <p>
                                <LanguageStringResolver string='acceptedFormats'/>
                                <span className="semi-bold">
                                    <LanguageStringResolver string={transactionFileTypes[0]}/>
                                </span>
                            </p>
                            <p>
                                <LanguageStringResolver string='transactionAttachment_maxFileSizeInMB'/>:
                                <br/>
                                <span>{`${MAX_FILE_SIZE_IN_MB} MB`}</span>
                            </p>
                            <p className="mb5"><LanguageStringResolver string='submitFilingDE_warning'/></p>
                            <p/>
                            <p className="mb5"><LanguageStringResolver string='rightToUse'/></p>
                        </s-box>
                        <br/>
                          <a className="button primary" onClick={this.onSubmitReport.bind(this)}><LanguageStringResolver string='submitFilingDE_Submit'/></a><a className="button secondary" onClick={() => this.onCloseModal()}><LanguageStringResolver string='submitFiling_cancel'/></a>
                    </div>
                </Modal>

            </>
        );
    }
}

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
    return {};
}

function mapDispatchersToProps(dispatch) {
    return {
        doSubmitDEReport: (certificateFile, reportUri, certificatePIN, reportType, filename, callback) => {
            log.debug('doSubmitDEReport() in dispatch');
            //let downloadInBrowser = ( filingTypeId !== 9)
            dispatch(FILING_CONTROLLER.doSubmitDEReport(certificateFile, reportUri, certificatePIN, reportType, filename, callback));
        }
    }
}
// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps,mapDispatchersToProps)(DESubmitFiling);
